// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a444cf15","455":"3bb6bb15","654":"6407c6eb","977":"7146c40e"}[chunkId] + ".chunk.js";
};